import type { InjectionToken } from 'tsyringe'
import type { GMOGateway, ElasticsearchGateway } from '@/interface/gateway'
import type { ToastStore } from '@/store/toast'
import type { CartStore } from '@/store/cart'
import type { NavigationStore } from '@/store/navigation'
import type { OrderStore } from '@/store/order'
import type { ProfileStore } from '@/store/profile'
import type { PokemonStore } from '@/store/pokemon'

export const DITokens = {
  // Gateway
  GMOGateway: 'GMOGateway' as InjectionToken<GMOGateway>,
  ElasticsearchGateway: 'ElasticsearchGateway' as InjectionToken<ElasticsearchGateway>,

  // Store
  CartStore: 'CartStore' as InjectionToken<CartStore>,
  NavigationStore: 'NavigationStore' as InjectionToken<NavigationStore>,
  OrderStore: 'OrderStore' as InjectionToken<OrderStore>,
  ToastStore: 'ToastStore' as InjectionToken<ToastStore>,
  ProfileStore: 'ProfileStore' as InjectionToken<ProfileStore>,
  PokemonStore: 'PokemonStore' as InjectionToken<PokemonStore>,
} as const
